export const EVENT_NAMES = {
    LOADER: "loader",
    NOTIFY: "notify",
}